angular.module("app").controller("LogoutController", [
    '$scope',
    'userService',
    'userStorage',
    'settingsService',
    '$state',
    function ($scope, userService, userStorage, settingsService, $state) {
        $scope.logout = function () {
            userService.logout().then(
                function (response) {
                    if (response.status === "ok") {
                        userStorage.resetUserData();
                        settingsService.reset();
                        $state.go("login");
                    } else {
                        //TODO handle error
                    }
                },
                function (response) {
                    //TODO handle error
                }
            )
        }
    }
])